import { forwardRef } from "react";
import Slide, { SlideProps } from "@mui/material/Slide";
import { CustomContentProps, PaxSnackbarAlert, PaxSnackbarContent } from "@ncino/pax-ui";
import { useSidebarExpanded } from "@/shared/hooks/useSidebarExpanded";
import { SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED } from "../paxSidebarConfig";

// Slides the snackbar in from the sidebar's right edge instead of the viewport
// edge. MUI's Slide measures its start offset from the container's left edge, so
// we hand it a rect anchored at the current sidebar width.
export const SidebarSlideTransition = forwardRef<HTMLDivElement, SlideProps>((props, ref) => {
  const [isSidebarExpanded] = useSidebarExpanded();
  const sidebarWidth = isSidebarExpanded ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH_COLLAPSED;

  const container = () =>
    ({
      getBoundingClientRect: () =>
        ({
          left: sidebarWidth,
          right: window.innerWidth,
          top: 0,
          bottom: window.innerHeight,
          width: window.innerWidth - sidebarWidth,
          height: window.innerHeight,
          x: sidebarWidth,
          y: 0,
        }) as DOMRect,
    }) as HTMLElement;

  return <Slide {...props} ref={ref} container={container} />;
});

SidebarSlideTransition.displayName = "SidebarSlideTransition";

const MainContentSnackbarAlert = forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {
  const { style } = props;
  const [isSidebarExpanded] = useSidebarExpanded();

  const sidebarWidth = isSidebarExpanded ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH_COLLAPSED;

  return (
    <PaxSnackbarContent ref={ref} style={{ ...style, marginLeft: sidebarWidth }}>
      <PaxSnackbarAlert {...props} style={{ width: "100%" }} />
    </PaxSnackbarContent>
  );
});

MainContentSnackbarAlert.displayName = "AlertSnackbar";

export default MainContentSnackbarAlert;
